import React, { Component } from 'react'

import { get, put } from '../../api'
import { emit } from '../../events'

import Form from '../Form/Form'

import './Synonyms.css'

class Synonyms extends Component {

	state = {}

	componentDidMount() {
		this.fetchSynonyms()
	}

	fetchSynonyms = async () => {
		try {
			const synonyms = await get('/synonyms')
			this.setState({
				synonyms: synonyms.map(row => row.join(', ')).join('\n')
			})
		} catch (err) {
			alert(err.message)
		}
	}

	onSubmit = async () => {
    	const { synonyms = '' } = this.state
    	try {
    		await put('/synonyms', {
    			synonyms: JSON.stringify(synonyms.split('\n').map(row => row.split(',')))
    		})
    		emit('snackbar', 'Synonyms saved!')
    	} catch (err) {
    		alert(err.message)
    	}
	}

    render() {
    	const { synonyms = '' } = this.state

        return (
            <div className="Synonyms">
            	<Form onSubmit={this.onSubmit}>
	            	<textarea
	            		spellCheck="false"
	            		value={synonyms}
	            		onChange={e => this.setState({ synonyms: e.target.value })}>
	            	</textarea>
	            	<div>
	            		<button>Save</button>
	            	</div>
	            </Form>
            </div>
        )
    }
}

export default Synonyms



// WEBPACK FOOTER //
// ./src/components/Synonyms/Synonyms.js